import { render } from "./AltFooter.vue?vue&type=template&id=0f6490c7&scoped=true"
import script from "./AltFooter.vue?vue&type=script&lang=js"
export * from "./AltFooter.vue?vue&type=script&lang=js"

import "./AltFooter.vue?vue&type=style&index=0&id=0f6490c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6490c7"]])

export default __exports__